<div class="grid-container">
    @if(gridConfigItems?.showSearch || gridConfigItems?.showFilter){
    <div class="grid-container__filter-search">
        @if(gridConfigItems?.showFilter){
        <div class="grid-container__filter">
            <div class="eod-input" [ngClass]="gridConfigItems?.searchBarClass">
                <label for="country" class="form-label">{{filterLabel}}</label>
                <ng-select [items]="dropdownList" bindLabel="dropdownName" bindValue="dropdownName"
                    [(ngModel)]="selectedFilter" (change)="handleFilterChange($event)" (clear)="onClear()"
                    [clearable]="false" [searchable]="true" class="select-dropdown select-dropdown--md"
                    [notFoundText]="textNotFound" name="dropdown">
                </ng-select>
                <small class="helper-text"></small>
            </div>
        </div>
        }
        @if(gridConfigItems?.showSearch){
        <div class="grid-container__search">
            <ds-textbox #searchField [textboxInput]="searchTextboxConfig"
                (valueChange)="onGridSearchTextChange($event)">
            </ds-textbox>
        </div>}
    </div>
    }
    <section class="ag-theme-alpine">
        <ag-grid-angular #agGrid class="ag-theme-alpine" style="width: 100%; height: 100%;"
            (gridReady)="onGridReady($event)" (cellClicked)="onCellClicked($event)" [gridOptions]="gridOptions"
            [rowHeight]="40" [theme]="'themeAlpine'" [sideBar]="true" [headerHeight]="40" [columnHoverHighlight]="false"
            [overlayNoRowsTemplate]="overlayNoRowsTemplate" [overlayLoadingTemplate]="overlayLoadingTemplate">
        </ag-grid-angular>
    </section>
</div>